import { Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IAppState, ReportActionCreators, CenterActionCreators } from '@nkr/store/index';
import { IAllCentersGridResponse } from '@nkr/store/reports';
import { IAllCentersGrid } from '@nkr/models/index';
import DirectoryGrid from './directory-grid'
import { downloadFile } from '@nkr/services/download-file';
import { OrganType } from '@nkr/enums/organ-type';

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getAllCentersData: () => Promise<IAllCentersGridResponse>,
    getPatientOutcomes: (centerId: number) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    centerData: IAllCentersGrid[],
    centerId: number
}

class AllCenters extends Component<TProps, IState> {
    readonly state: IState = {
        centerData: [],
        centerId: 0
    }

    handleGetPatientOutcomes = (centerId: number) => {
        this.props.getPatientOutcomes(centerId)
            .then((response: any) => {
                downloadFile(response.data, `patient-outcomes-${centerId}.pdf`, 'application/pdf');
            });
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading("Getting Center Data, please wait").then(() => {
            this.props.getAllCentersData()
                .then((centerDataResponse) => {
                    let centerData = centerDataResponse.data.results;

                    if (this.props.app.site.organType == OrganType.Liver) {
                        centerData = centerData.filter(x => x.isDashLiverParticipant);
                    }

                    this.setState({
                        centerData
                    }, () => {
                        this.props.hideLoading()
                    });
                })
                .catch(() => {
                    this.props.hideLoading();
                });
        });
    }

    render = () => {
        return (
            <DirectoryGrid
                centerData={this.state.centerData}
                isAdmin={this.props.isAdmin}
                centerId={this.props.centerId}
                onGetPatientOutcomes={this.handleGetPatientOutcomes}
            />
        )
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getAllCentersData: () => {
            return dispatch(ReportActionCreators.getAllCentersData());
        },
        getPatientOutcomes: (centerId) => {
            return dispatch(CenterActionCreators.getPatientOutcomes(centerId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(AllCenters);